export const FAULT_MGMT_ALARMS = 'alarms';
export const FAULT_MGMT_TYPE = 'faultManagement';
export const DEFAULT_SHELVE_DURATION = 90000;
export const FAULT_MGMT_ACTIONS = Object.freeze({
    SHELVE: 'shelve',
    UNSHELVE: 'unshelve',
    ACKNOWLEDGE: 'acknowledge',
    CLEAR: 'clear'
});
